import React from "react";
import UserGuideView from './../../components/views/user-guide-view/UserGuide.jsx';

export default function UserGuidePage() {
  return <UserGuideView />;
}
